import * as React from 'react';
import { cn } from '@/lib/utils';

export const Input = React.forwardRef(({ className, type, ...props }, ref) => (
  <input
    type={type}
    ref={ref}
    className={cn(
      // h-10 to match the button, so a field and the button beside it line up without a
      // per-form nudge — the commonest cause of a toolbar looking slightly wrong.
      'flex h-10 w-full rounded-lg border border-input bg-background px-3 py-1 text-sm shadow-subtle',
      'transition-[border-color,box-shadow] duration-150',
      'placeholder:text-muted-foreground hover:border-muted-foreground/40',
      'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:border-ring',
      'disabled:cursor-not-allowed disabled:opacity-50',
      'aria-[invalid=true]:border-destructive aria-[invalid=true]:focus-visible:ring-destructive',
      className,
    )}
    {...props}
  />
));
Input.displayName = 'Input';
